import { EmbeddedRecordsMixin } from '@warp-drive/legacy/serializer/rest';

import Serializer from 'umg-ember-backend/serializers/application';

export default class LabelSerializer extends Serializer.extend(
  EmbeddedRecordsMixin,
) {
  attrs = {
    asset: 'assetId',
  };
}
